import React, { useState, KeyboardEvent } from 'react';
import { Box, TextField, IconButton, Paper } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { ArrowUpward } from '@mui/icons-material';

interface MatchPanelInputProps {
  onSend: (message: string) => void;
  disabled?: boolean;
}

export const MatchPanelInput: React.FC<MatchPanelInputProps> = ({ onSend, disabled }) => {
  const theme = useTheme();
  const [value, setValue] = useState('');

  const handleSend = () => {
    if (value.trim() && !disabled) {
      onSend(value);
      setValue('');
    }
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Box
      sx={{
        p: 2,
        bgcolor: alpha(theme.palette.background.default, 0.8),
        backdropFilter: 'blur(8px)',
      }}
    >
      <Paper
        elevation={2}
        sx={{
          borderRadius: 4,
          overflow: 'hidden',
          boxShadow: theme.shadows[2],
          border: '1px solid',
          borderColor: alpha(theme.palette.divider, 0.1),
        }}
      >
        <TextField
          fullWidth
          multiline
          maxRows={4}
          placeholder="Type a message..."
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          size="small"
          sx={{
            '& .MuiOutlinedInput-root': {
              pr: 1,
              fontSize: '0.9rem',
              '& fieldset': {
                border: 'none',
              },
            },
            '& .MuiInputBase-input': {
              py: 1.5,
              px: 2,
            },
          }}
        />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            px: 1.5,
            py: 1,
            bgcolor: 'background.paper',
          }}
        >
          <IconButton
            onClick={handleSend}
            disabled={!value.trim() || disabled}
            sx={{
              bgcolor: '#cc5544',
              color: 'white',
              width: 32,
              height: 32,
              '&:hover': {
                bgcolor: '#b54636',
              },
              '&.Mui-disabled': {
                bgcolor: alpha('#cc5544', 0.3),
                color: 'white',
              },
            }}
          >
            <ArrowUpward fontSize="small" />
          </IconButton>
        </Box>
      </Paper>
    </Box>
  );
};
